module.exports = __webpack_public_path__ + "static/img/Platinum.bdae32d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/vip/Platinum.svg
// module id = qcjl
// module chunks = 1